module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-171.573f84dd.jpg";